export const GA_ID = "G-LFDY9KR9P0";

export const gaEvent = (name, params = {}) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
};

export const gaPageView = (path) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }
};

// Google Ads conversion (AW-827804733). Optionally navigates to `url` after the
// event is registered. Safe no-op (still navigates) if gtag isn't loaded.
export const ADS_CONVERSION_SEND_TO = "AW-827804733/W-fACNqT6I0bEL2Y3YoD";

export const reportAdsConversion = (url) => {
  const go = () => { if (typeof url !== "undefined" && url) window.location = url; };
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    go();
    return;
  }
  window.gtag("event", "conversion", {
    send_to: ADS_CONVERSION_SEND_TO,
    value: 1.0,
    currency: "USD",
    event_callback: go,
  });
};

// --- Lead-capture conversion tracking (env-driven, CRA uses REACT_APP_*) ---
const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID || "";
const REPORT_LABEL = process.env.REACT_APP_GOOGLE_ADS_REPORT_LABEL || "";
const BROKER_LABEL = process.env.REACT_APP_GOOGLE_ADS_BROKER_LABEL || "";

// Fire a Google Ads conversion. Safe: logs a clean notice instead of throwing
// when gtag isn't loaded or the env config is missing.
const fireAdsConversion = (label, source) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    console.info(`[ads] gtag not loaded — skipped ${source} Ads conversion.`);
    return;
  }
  if (!ADS_ID || !label) {
    console.info(`[ads] REACT_APP_GOOGLE_ADS_ID / label for ${source} not set — skipped Ads conversion (GA4 event still sent).`);
    return;
  }
  window.gtag("event", "conversion", {
    send_to: `${ADS_ID}/${label}`,
    value: 1.0,
    currency: "USD",
  });
};

// Primary conversion — successful Report Request submission (200 OK + saved).
export const trackReportConversion = () => {
  fireAdsConversion(REPORT_LABEL, "report_request");
  gaEvent("generate_lead", { event_category: "valuation_funnel", event_label: "report_request" });
};

// Secondary conversion — successful Broker Review / in-person CMA request.
export const trackBrokerConversion = () => {
  fireAdsConversion(BROKER_LABEL, "broker_review");
  gaEvent("generate_lead", { event_category: "valuation_funnel", event_label: "broker_review" });
};
